<auth-header></auth-header>
<form #form="ngForm" (ngSubmit)="onSubmit(form)" novalidate>
  <div class="name">
    <ui-input class="first-name required">
      <input
        uiInput
        type="text"
        #firstName="ngModel"
        name="firstName"
        [(ngModel)]="registration.firstName"
        placeholder="First Name"
        nameValidator
        maxlength="128"
        required
      />
      <ui-input-error [input]="firstName" name="required">First Name is required</ui-input-error>
      <ui-input-error [input]="firstName" name="name">First Name is invalid</ui-input-error>
    </ui-input>
    <ui-input class="last-name required">
      <input
        uiInput
        type="text"
        name="lastName"
        #lastName="ngModel"
        [(ngModel)]="registration.lastName"
        placeholder="Last Name"
        nameValidator
        maxlength="128"
        required
      />
      <ui-input-error [input]="lastName" name="required">Last Name is required</ui-input-error>
      <ui-input-error [input]="lastName" name="name">Last Name is invalid</ui-input-error>
    </ui-input>
  </div>
  <ui-input class="email required">
    <input
      uiInput
      #email="ngModel"
      type="email"
      name="email"
      [(ngModel)]="registration.email"
      placeholder="Email"
      emailValidator
      maxlength="264"
      required
    />
    <ui-input-error [input]="email" name="required">Email is required</ui-input-error>
    <ui-input-error [input]="email" name="email">Email is invalid</ui-input-error>
  </ui-input>
  <ui-input class="required">
    <input
      uiInput
      type="text"
      name="company"
      #company="ngModel"
      [(ngModel)]="registration.company"
      placeholder="Company"
      minlength="3"
      maxlength="256"
      required
    />
    <ui-input-error [input]="company" name="minlength">Company name should be at least 3 characters long
    </ui-input-error>
    <ui-input-error [input]="company" name="required">Company name is required</ui-input-error>
  </ui-input>
  <ui-input class="phone">
    <input
      uiInput
      #phone="ngModel"
      type="tel"
      name="phone"
      [(ngModel)]="registration.phone"
      placeholder="Phone Number"
      phoneValidator
    />
    <ui-input-error [input]="phone" name="phone">Phone is invalid</ui-input-error>
  </ui-input>
  <div class="country required">
    <ng-select
      uiInput
      name="country"
      #country="ngModel"
      [options]="filteredCountries"
      (selected)="countriesSelected($event)"
      (filterInputChanged)="onFilterInputChanged($event)"
      [(ngModel)]="registration.country"
      [attr.dirty]="registration.country"
      placeholder="Country"
      required
      (closed)="onSelectClosed()"
    >
    </ng-select>
    <span class="placeholder">Country</span>
    <ui-input-error [input]="country" name="required">Country is required</ui-input-error>
  </div>
  <ui-input class="project-details">
    <textarea
      uiInput
      name="projectDetails"
      #projectDetails="ngModel"
      [(ngModel)]="registration.projectDetails"
      placeholder="Project details. What kind of documents are you going to process?"
      cols="20"
      rows="4"
      maxlength="1024"
    >
    </textarea>
    <ui-input-error
      [input]="projectDetails"
      name="maxlength"
      [showErrorValidation]="isLengthMaxProjectDetails()"
    >
      Project details should be at no more 1024 characters
    </ui-input-error>
  </ui-input>
  <div class="subscribe-block required" *ngIf="policy">
    <ui-checkbox
      required="true"
      class="reg-checkbox"
      name="tosCheckbox"
      [(ngModel)]="registration.tosCheckbox"
      required
      tabindex="0"
    >
      I accept the
      <a href="{{ settings.tos.url }}" target="_blank">Terms Of Service</a>.
    </ui-checkbox>
    <ui-checkbox
      class="reg-checkbox"
      name="privacyAndCookie"
      [(ngModel)]="registration.privacyAndCookie"
      required
      tabindex="0"
      *ngIf="policy.type !== 'US' && policy.type !== 'CA_JP'"
    >
      I have read and agree with the
      <a href="{{ policy.privacyPolicyUrl }}" target="_blank">Privacy policy</a>
      and the
      <a href="{{ policy.cookiePolicyUrl }}" target="_blank">Cookie policy</a>.
    </ui-checkbox>
    <ui-checkbox
      class="reg-checkbox"
      name="subscribeToEmails"
      [(ngModel)]="registration.subscribeToEmails"
      tabindex="0"
      *ngIf="policy.type !== 'US'"
    >
      <span *ngIf="policy.type === 'ALL' || policy.type === 'EU'">
        I agree to receive email updates from ABBYY Europe GmbH such as news
        related to ABBYY Europe GmbH products and technologies, invitations to
        events and webinars, and information about whitepapers and content related
        to ABBYY Europe GmbH products and services.
        I am aware that my consent could be revoked at any time by clicking the unsubscribe
        link inside any email received from ABBYY Europe GmbH or via
        <a href="https://www.abbyy.com/en-us/dsarwebform/">ABBYY Data Subject Access Rights Form.</a>
      </span>
      <span *ngIf="policy.type === 'SOLUTIONS'">
        I agree to receive email updates from ABBYY Solutions Ltd. such as news
        related to ABBYY Solutions Ltd. products and technologies, invitations to
        events and webinars, and information about whitepapers and content related
        to ABBYY Solutions Ltd. products and services.
        I am aware that my consent could be revoked at any time by clicking the unsubscribe
        link inside any email received from ABBYY Solutions Ltd. or via
        <a href="https://www.abbyy.com/en-us/dsarwebform/">ABBYY Data Subject Access Rights Form.</a>
      </span>
      <span *ngIf="policy.type === 'CA_JP'">
        Please keep me informed about new products and updates. I understand I
        may unsubscribe at any time from emails that will be sent to me from
        ABBYY USA Software House Inc. ("ABBYY North American Head Quarters")
      </span>
    </ui-checkbox>
    <div *ngIf="policy.type === 'US' || policy.type === 'CA_JP'">
      By submitting this form, I consent to the use of my personal information
      for the purposes described in the
      <a href="{{ policy.privacyPolicyUrl }}" target="_blank">Privacy Notice</a>.
    </div>
  </div>
  <div
    class="ui-input-error"
    *ngIf="error"
    [class.visible]="error"
  >
    <span>{{ errorDescription }}</span>
  </div>
  <input type="checkbox" name="checkbox" id="def-checkbox" class="def-checkbox"
         onchange="document.getElementById('register').disabled = this.checked;"/>
  <button type="submit" id="register" class="default" (click)="validate(form)">
    Register
  </button>
  <p>Already have an account? <a routerLink="/login">Login here</a></p>
  <ui-loading *ngIf="processing"></ui-loading>
</form>
<auth-footer></auth-footer>
